import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { API } from "../../App";

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });
const byName = (a, b) => a.name.localeCompare(b.name);
const PATHS = { area: "defect-areas", element: "defect-elements", issue: "defect-issues" };

export const useDefectOptions = (siteId) => {
  const [opts, setOpts] = useState({ area: [], element: [], issue: [], contractors: [] });

  useEffect(() => {
    if (!siteId) return;
    const get = (p) => fetch(`${API}/${p}`, { headers: auth() }).then((r) => (r.ok ? r.json() : []));
    Promise.all([get(PATHS.area), get(PATHS.element), get(PATHS.issue), get("companies"), get(`defects?site_id=${siteId}`)])
      .then(([area, element, issue, companies, siteDefects]) => {
        const assigned = new Set(siteDefects.map((d) => d.assigned_to).filter(Boolean));
        const contractors = companies
          .filter((c) => ["contractor", "subcontractor"].includes(c.company_type)
            && ((c.site_ids || []).includes(siteId) || assigned.has(c.id)))
          .sort(byName);
        setOpts({ area: area.sort(byName), element: element.sort(byName), issue: issue.sort(byName), contractors });
      });
  }, [siteId]);

  const addOption = useCallback(async (kind, name) => {
    const clean = name.trim();
    if (!clean) return toast.error("Please enter a name"), null;
    if (opts[kind].some((o) => o.name.toLowerCase() === clean.toLowerCase())) return toast.error("This already exists"), null;
    const res = await fetch(`${API}/${PATHS[kind]}`, {
      method: "POST", headers: { ...auth(), "Content-Type": "application/json" }, body: JSON.stringify({ name: clean }),
    });
    if (!res.ok) return toast.error("Could not add it"), null;
    const created = await res.json();
    setOpts((o) => ({ ...o, [kind]: [...o[kind], created].sort(byName) }));
    return created.name;
  }, [opts]);

  return { ...opts, addOption };
};
